import { jsxs as p, jsx as a } from "react/jsx-runtime";
import { c as g } from "./index.CWkFp9WS.js";
import '../assets/ODSIcon.css';/* empty css                 */
const m = ({
  size: o,
  fill: r = "currentColor",
  color: n = "currentColor",
  selected: d = !1,
  decorative: h = !1,
  accessibilityTitle: l,
  focusable: s = !1,
  small: e = !1,
  className: c,
  ...i
}) => {
  const t = o || (e ? 16 : 24);
  return /* @__PURE__ */ p(
    "svg",
    {
      className: g("ODSIcon", c),
      xmlns: "http://www.w3.org/2000/svg",
      width: t,
      height: t,
      viewBox: e ? "0 0 16 16" : "0 0 24 24",
      "aria-hidden": !!h,
      tabIndex: s ? 0 : -1,
      ...i,
      children: [
        l && /* @__PURE__ */ a("title", { children: l }),
        /* @__PURE__ */ a("g", { fill: r === "currentColor" ? n : r, children: d ? e ? /* @__PURE__ */ a("g", { children: /* @__PURE__ */ a("path", { d: "M13.067 5.435a.8.8 0 0 0-1.132 0L8.502 8.869 5.067 5.435a.8.8 0 1 0-1.132 1.13l4 4a.8.8 0 0 0 1.132 0l4-4a.8.8 0 0 0 0-1.13" }) }) : /* @__PURE__ */ a("g", { children: /* @__PURE__ */ a("path", { d: "M19.384 8.116a1.25 1.25 0 0 0-1.768 0L12.5 13.232 7.384 8.116a1.25 1.25 0 1 0-1.768 1.768l6 6a1.25 1.25 0 0 0 1.768 0l6-6a1.25 1.25 0 0 0 0-1.768" }) }) : e ? /* @__PURE__ */ a("g", { children: /* @__PURE__ */ a("path", { d: "M12.924 5.576a.6.6 0 0 0-.849 0L8.5 9.152 4.924 5.576a.6.6 0 0 0-.849.848l4 4a.6.6 0 0 0 .849 0l4-4a.6.6 0 0 0 0-.848" }) }) : /* @__PURE__ */ a("g", { children: /* @__PURE__ */ a("path", { d: "M19.207 8.293a1 1 0 0 0-1.414 0L12.5 13.586 7.207 8.293a1 1 0 0 0-1.414 1.414l6 6a1 1 0 0 0 1.414 0l6-6a1 1 0 0 0 0-1.414" }) }) })
      ]
    }
  );
};
export {
  m as default
};
//# sourceMappingURL=ODSCollapseDown.a8_lm2jI.js.map
